import { forwardRef, type ReactElement, type Ref, type SVGProps } from 'react'

const RingIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
): ReactElement => (
  <svg
    width="25"
    height="32"
    viewBox="0 0 25 32"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12.334 32C5.73398 32 0.333984 26.6 0.333984 20C0.333984 13.4 5.73398 8 12.334 8C18.934 8 24.334 13.4 24.334 20C24.334 26.6 18.934 32 12.334 32ZM12.334 9.5C6.53398 9.5 1.83398 14.2 1.83398 20C1.83398 25.8 6.53398 30.5 12.334 30.5C18.134 30.5 22.834 25.8 22.834 20C22.834 14.2 18.134 9.5 12.334 9.5ZM12.334 28.5C7.63398 28.5 3.83398 24.7 3.83398 20C3.83398 15.3 7.63398 11.5 12.334 11.5C17.034 11.5 20.834 15.3 20.834 20C20.834 24.7 17.034 28.5 12.334 28.5ZM12.334 13C8.43398 13 5.33398 16.1 5.33398 20C5.33398 23.9 8.43398 27 12.334 27C16.234 27 19.334 23.9 19.334 20C19.334 16.1 16.234 13 12.334 13Z"
    />
    <path
      d="M12.3342 9.5C9.73418 9.5 7.53418 7.4 7.53418 4.7C7.53418 2 9.73418 0 12.3342 0C14.9342 0 17.1342 2.1 17.1342 4.8C17.1342 7.5 14.9342 9.5 12.3342 9.5ZM12.3342 1.5C10.5342 1.5 9.03418 3 9.03418 4.8C9.03418 6.6 10.5342 8 12.3342 8C14.1342 8 15.6342 6.5 15.6342 4.7C15.6342 2.9 14.1342 1.5 12.3342 1.5Z"
    />
  </svg>
)

export default forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(RingIcon)
